import React, { useCallback, useMemo } from "react"

import DownloadIcon from "images/inline/ugc/download.svg"
import Facebook from "images/inline/editorial/facebook.svg"
import Mail from "images/inline/editorial/mail.svg"
import Whatsapp from "images/inline/editorial/whatsapp.svg"
import Pinterest from "images/inline/editorial/pinterest.svg"
import Twitter from "images/inline/editorial/twitter.svg"
import LinkShare from "components/LinkShare"
import ShareIcon from "components/ShareIcon"
import "./ShareIcons.scss"

/*

    This component allows users to share links to social media.
    The parameters included here will alter the content visible on social media.
    For more background: https://thedailybreak.atlassian.net/wiki/spaces/D2/pages/1697218561/Social+Sharing

    The format shared on social media will look like:
        /break/<permalink>?step=<stepId>&result=<resultId>&submission=<submissionId>

    Different types of steps can share different types of content:

        Personality Quiz
            include the stepId and resultId parameters to share the quiz result "What Kind of Cheese are you? I'm a Gouda!"

        Photo Upload
            include the stepId and submissionId parameters to share the asset generated by the consumer
            If given the prop "download", will generate a download link for user-generated image. download muct be valid base64-encoded jpeg.

    IMPORTANT: Server-side work is required to resolve the shared content based on the step type - don't assume it will Just Work.

    TODO: we infer the permalink based on window.location. Figure out how to pass it instead?

    legacy also included printing and downloading as options

*/

const ShareIcons = ({ stepId, galleryItemId, resultId, submissionId, shareCopy = null, facebookShare = false, twitterShare = false, pinterestShare = false, emailShare = false, emailConfig = {}, copyShare = false, whatsappShare = false, download = null, shareUrl, isEmbed, onShareClick = function (platform) {} }) => {
    let params = {}
    if (stepId) {
      params["stepId"] = stepId
    }
    if (galleryItemId) {
      params["galleryitem"] = galleryItemId
    }
    if (resultId) {
      params["resultId"] = resultId
    }
    if (submissionId) {
      params["submissionId"] = submissionId
    }

    let pairs = []
    for (let param in params) {
      pairs.push(encodeURIComponent(param) + "=" + encodeURIComponent(params[param]))
    }
    let search = pairs.join("&")
    if (search) {
      search = "?" + search
    }

    const url = encodeURIComponent(shareUrl ? shareUrl : (typeof window !== "undefined" ? window.location.href : "") + search)

    shareCopy = encodeURIComponent(shareCopy || (typeof window !== `undefined` && document.title ? document.title : ""))

  // simple wrapper to let us catch any analytics issues and always return true
  const handleClick = ({ platform, link }) => {
    try {
      onShareClick({ platform, link })
    } catch (e) {
      console.log(e)
    }
    return true
  }

  const { subject = "", body = "" } = emailConfig

  //To pass the url context properly to click handler, imma define 'em here.
  const pinterestURL = `https://pinterest.com/pin/create/button/?url=${url}&description=${shareCopy}`
  const facebookURL = `https://www.facebook.com/sharer/sharer.php?u=${url}`
  const twitterURL = `https://twitter.com/share?text=${shareCopy}&url=${url}`
  const mailLink = `mailto:info@example.com?&cc=&bcc=&subject=${subject || shareCopy}:${url}&body=${body}`
  const whatsappURL = `https://api.whatsapp.com/send?text=${shareCopy}:${url}`
  return (
        <div className="share-icons">
          <ul>
            {download && (
              <ShareIcon
                className="icon-download"
                href={download}
                download={true}
                handleClick={handleClick.bind(this, {
                  platform: "download",
                  link: download,
                })}
                icon={DownloadIcon}
              />
            )}
            {emailShare && <ShareIcon className="icon-email" href={mailLink} ariaLabel="Share via Email" handleClick={handleClick.bind(this, { platform: "email" })} icon={Mail} />}
            {copyShare && (
              <ShareIcon
                className="icon-link"
                href={url}
                handleClick={handleClick.bind(this, {
                  platform: "link-copy",
                  link: url,
                })}
                icon={LinkShare}
              />
            )}
            {facebookShare && (
              <ShareIcon
                className="icon-facebook"
                href={facebookURL}
                ariaLabel="Share to Facebook"
                handleClick={handleClick.bind(this, {
                  platform: "facebook",
                  link: facebookURL,
                })}
                icon={Facebook}
              />
            )}
            {pinterestShare && (
              <ShareIcon
                className="icon-pinterest"
                href={pinterestURL}
                ariaLabel="Share to Pinterest"
                handleClick={handleClick.bind(this, {
                  platform: "pinterest",
                  link: pinterestURL,
                })}
                icon={Pinterest}
              />
            )}
            {twitterShare && (
              <ShareIcon
                className="icon-twitter"
                href={twitterURL}
                ariaLabel="Share to Twitter"
                handleClick={handleClick.bind(this, {
                  platform: "twitter",
                  link: twitterURL,
                })}
                icon={Twitter}
              />
            )}
            {whatsappShare && (
              <ShareIcon
                className="icon-whatsapp"
                href={whatsappURL}
                ariaLabel="Share to WhatsApp"
                handleClick={handleClick.bind(this, {
                  platform: "whatsapp",
                  link: whatsappURL,
                })}
                icon={Whatsapp}
              />
            )}
          </ul>
        </div>
  )
}

export default ShareIcons
